<template>
  <footer class="bgimg-1 w3-center w3-grayscale-min w3-black w3-padding-64" 
  style="background-position-x: 0%;  background-position-y: 100%;background-attachment: fixed;">
    <a href="#home" class="w3-button w3-hover-black" style="background: rgba(10,10,10,0.5);">
      <i class="fa fa-arrow-up w3-margin-right"></i>{{ $t('footer.toTop') }}
    </a>
    <!-- <div class="w3-xlarge w3-section">
      <i class="fa fa-facebook-official w3-hover-opacity"></i>
      <i class="fa fa-instagram w3-hover-opacity"></i>
      <i class="fa fa-snapchat w3-hover-opacity"></i>
      <i class="fa fa-pinterest-p w3-hover-opacity"></i>
      <i class="fa fa-twitter w3-hover-opacity"></i>
      <i class="fa fa-linkedin w3-hover-opacity"></i>
    </div> -->
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>